var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.48,
    height: 26,
    viewBox: "0 0 25.48 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{clip-rule:evenodd;}.c{clip-path:url(#a);}.d{clip-path:url(#b);}.e{fill:#ea4334;}.f{clip-path:url(#c);}.g{fill:#4184f3;}.h{clip-path:url(#e);}.i{fill:#fabb04;}.j{clip-path:url(#g);}.k{fill:#34a753;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.573-12.973A7.205,7.205,0,0,1,17.6-11.038l3.669-3.582a12.49,12.49,0,0,0-8.7-3.38A12.991,12.991,0,0,0,.96-10.836l4.2,3.264a7.858,7.858,0,0,1,7.41-5.4Z",
    transform: "translate(-0.96 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,8H26V-18H0Z",
    transform: "translate(0 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.48-7.982a11.137,11.137,0,0,0-.274-2.658H9v4.824h7.164A6.354,6.354,0,0,1,13.507-1.6l4.1,3.178A12.71,12.71,0,0,0,21.48-7.982Z",
    transform: "translate(-9 10.64)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.6-4.633A8,8,0,0,1,5.171-7.2,8.41,8.41,0,0,1,5.59-9.776l-4.2-3.264A13.011,13.011,0,0,0,0-7.2,13.011,13.011,0,0,0,1.387-1.369L5.6-4.633Z",
    transform: "translate(0 13.04)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.569,3.209A12.39,12.39,0,0,0,21.178.06l-4.1-3.178a7.694,7.694,0,0,1-4.507,1.3,7.826,7.826,0,0,1-7.4-5.4L.97-3.956a12.969,12.969,0,0,0,11.6,7.164Z",
    transform: "translate(-0.97 7.22)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(1.387 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-1.387)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-4.04-23H30.713V1.873H-4.04Z",
    transform: "translate(-1.796 15.778)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(13 -7.369)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-13 -10.631)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M4-15.64H30.924V11.024H4Z",
    transform: "translate(1.778 19.049)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(0 -10.836)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(0 -7.164)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M-5-18.04H15.049V8.076H-5Z",
    transform: "translate(-2.222 17.982)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(1.401 -2.429)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(-1.401 -15.571)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M-4.03-12.22H30.622V12.653H-4.03Z",
    transform: "translate(-1.791 20.569)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.191c9b37197e34c5d115262b53d9b16b.svg";
export { ForwardRef as ReactComponent };